import Header from "../components/Header";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { Outlet } from "react-router-dom";

const FullLayout = () => {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: 'background.default' }}>
      <Header />
      <Box component="main" sx={{ flexGrow: 1, py: 3.5 }}>
        <Container maxWidth="xl">
          <Outlet />
        </Container>
      </Box>
    </Box>
  );
};

export default FullLayout;
